<div class="user-profile-container" [class.open]="isOpen">

  <!-- Profile header: cover image + user info (never scrolls) -->
  <div class="profile-header" *ngIf="!isCommunity">

    <div class="profile-info-section">
      <div class="cover-image"
        [style.background-image]="userProfile?.cover_image_url ? 'url(' + userProfile.cover_image_url + ')' : 'url(/assets/home/profile/banner_profile.webp)'">
      </div>

      <div class="user-details">
        <div class="avatar-container">
          <img *ngIf="profileImage" [src]="profileImage" class="avatar" alt="Avatar" />
          <div *ngIf="!profileImage && userProfile" class="initials-fallback">
            {{ getInitials() }}
          </div>
          <input type="file" accept="image/*" #fileInput hidden (change)="onImageSelected($event)" />
          <app-camera-button ariaLabel="Update profile photo" (clicked)="fileInput.click()"></app-camera-button>
        </div>

        <div class="info-row" *ngIf="!isLoading && userProfile">
          <div class="name-section">
            <span class="heading-name">{{getName(userProfile.first_name, userProfile.last_name)}}</span>
            <div class="stats-links">
              <span class="link" (click)="setActiveTab('dockmates')">{{ userProfile.friends_count || 0 }} {{
                userProfile.friends_count <= 1 ? 'Dockmate' : 'Dockmates' }}</span>
                  <span class="link" (click)="setActiveTab('fleets')">{{ userProfile.communities_count || 0 }} {{
                    userProfile.communities_count <= 1 ? 'Fleet' : 'Fleets' }}</span>
            </div>
          </div>

          <div class="stats-counter">
            <div class="stat-item">
              <span class="label">Boat Name</span>
              <span class="value">{{ userProfile.vessel_name || 'No Vessel' }}</span>
            </div>
            <div class="stat-item">
              <span class="label">Activities</span>
              <span class="value">{{ userProfile.activities_count || 0 }}</span>
            </div>
            <div class="stat-item">
              <span class="label">Distance</span>
              <span class="value">{{ (userProfile.distance_covered || 0.0) | number:'1.1-2' }} nmi</span>
            </div>
          </div>
        </div>

        <div class="info-row loading-placeholder" *ngIf="isLoading">
          <div class="name-section">
            <div class="skeleton skeleton-name"></div>
            <div class="stats-links">
              <div class="skeleton skeleton-link"></div>
              <div class="skeleton skeleton-link"></div>
            </div>
          </div>
          <div class="stats-counter">
            <div class="skeleton skeleton-stat" *ngFor="let i of [1,2,3]"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabs navigation (never scrolls) -->
  <div class="tabs-navigation">
    <ng-container *ngIf="isCommunity; else personalTabs">
      <button class="tab-btn" [class.active]="activeTab === 'watch'" (click)="setActiveTab('watch')">Watch</button>
      <button class="tab-btn" [appTourAnchor]="'profile.captainsTab'" [class.active]="activeTab === 'dockmates'"
        (click)="setActiveTab('dockmates')">Captains</button>
      <button class="tab-btn" [appTourAnchor]="'profile.fleetsTab'" [class.active]="activeTab === 'fleets'"
        (click)="setActiveTab('fleets')">Fleets</button>
    </ng-container>
    <ng-template #personalTabs>
      <button class="tab-btn" [class.active]="activeTab === 'trips'" (click)="setActiveTab('trips')">Trips</button>
      <button class="tab-btn" [class.active]="activeTab === 'waypoints'"
        (click)="setActiveTab('waypoints')">Waypoints</button>
      <button class="tab-btn" [class.active]="activeTab === 'photos'" (click)="setActiveTab('photos')">Photos</button>
      <button class="tab-btn" [class.active]="activeTab === 'posts'" (click)="setActiveTab('posts')">Posts</button>
      <button class="tab-btn" [appTourAnchor]="'profile.vesselsTab'" [class.active]="activeTab === 'vessels'"
        (click)="setActiveTab('vessels')">Vessels</button>
      <button class="tab-btn" [appTourAnchor]="'profile.settingsTab'" [class.active]="activeTab === 'settings'"
        (click)="setActiveTab('settings')">Settings</button>
    </ng-template>
    <!-- Learning Center entry point -->
    <button class="tab-btn tab-btn--learn" (click)="openLearningCenter()" title="Learning Center"
      aria-label="Learning Center">
      <span class="material-icons">help_outline</span>
    </button>
  </div>

  <!-- Only cards scroll inside this -->
  <div class="content-area">
    <app-watch *ngIf="activeTab === 'watch'" (openFullProfile)="onOpenFullProfile($event)"></app-watch>
    <app-dockmates *ngIf="activeTab === 'dockmates'" [initialSubTab]="initialSubTab" [initialMateId]="initialId"
      (tabChange)="setActiveTab($event)" (openFullProfile)="onOpenFullProfile($event)" ></app-dockmates>
    <app-fleets *ngIf="activeTab === 'fleets'" [initialSubTab]="initialSubTab"
      [initialFleetId]="initialId"></app-fleets>
    <app-trips *ngIf="activeTab === 'trips'" [initialTripId]="initialId" (fleetSelected)="selectedSidebarFleet = $event"></app-trips>
    <app-waypoints *ngIf="activeTab === 'waypoints'" [initialWaypointId]="initialId" [userProfile]="userProfile"
      [profileImage]="profileImage" (fleetSelected)="selectedSidebarFleet = $event"
      (openFullProfile)="onOpenFullProfile($event)"></app-waypoints>
    <app-photos *ngIf="activeTab === 'photos'" [userProfile]="userProfile" [profileImage]="profileImage"></app-photos>
    <app-posts *ngIf="activeTab === 'posts'" [userProfile]="userProfile" [profileImage]="profileImage"></app-posts>
    <app-settings *ngIf="activeTab === 'settings'" (profileUpdated)="onSettingsProfileUpdated($event)"></app-settings>
    <app-vessels *ngIf="activeTab==='vessels'"></app-vessels>
  </div>
</div>

<app-fleet-detail *ngIf="selectedSidebarFleet" [fleet]="selectedSidebarFleet" [hideActivity]="false"
  (close)="selectedSidebarFleet = null">
</app-fleet-detail>

<app-dockmate-full-profile-page
  *ngIf="showFullProfileOverlay"
  [embedded]="true"
  [profileId]="selectedFullProfileId"
  [profileObject]="selectedFullProfileObject"
  [activeTabName]="nestedActiveTab"
  (closed)="closeFullProfileOverlay()"
  (navigateToVessels)="openVesselsTab()"
  (updateSyncList)="syncDockmatesList($event)">
</app-dockmate-full-profile-page>
